import { render, staticRenderFns } from "./SidebarMenuHelp.vue?vue&type=template&id=119b0fa6&scoped=true&"
import script from "./SidebarMenuHelp.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuHelp.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMenuHelp.vue?vue&type=style&index=0&id=119b0fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b0fa6",
  null
  
)

export default component.exports